import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import TruckMarker from './TruckMarker';
import { Alert, Avatar, Button, Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Stack, ToggleButton, Tooltip, Typography, List, Grid } from "@mui/material";
import _ from "lodash";
import { geoCoords, getAssetPath } from "app/utils/appHelpers";
import Div from "@jumbo/shared/Div";
import { GoogleMap, InfoWindow, Marker, Polygon, Polyline, useLoadScript } from "@react-google-maps/api";
import RefreshIcon from '@mui/icons-material/Refresh';
import TollOutlinedIcon from '@mui/icons-material/TollOutlined';
import BatteryCharging90OutlinedIcon from '@mui/icons-material/BatteryCharging90Outlined';
import SwapVertIcon from '@mui/icons-material/SwapVert';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';
import SaveOutlinedIcon from '@mui/icons-material/SaveOutlined';
import FlagRoundedIcon from '@mui/icons-material/FlagRounded';
import { AuthContext } from "@jumbo/components/JumboAuthProvider/JumboAuthContext"

import tripServices from "app/services/trip-services"
import moment from 'moment';
import { arrayMove, SortableContainer } from 'react-sortable-hoc';
import DeliveryCell from './DeliveryCell';
import { LoadingButton } from '@mui/lab';
import { ASSET_IMAGES } from 'app/utils/constants/paths';
import CustomMarker from '../../widgets/Markers';
import { GOOGLE_MAPS_API_KEY } from 'app/utils/constants/paths';
import { deliveryLocation, getDeliveryDestination, stopNumbersByDeliveryId } from 'app/utils/tripStops';
import { getCarrierMarkerColor, getDropoffMarkerStyle, getFinishMarkerIcon, FINISH_MARKER_COLOR } from 'app/utils/mapMarkers';
import shippingServices from 'app/services/shipping-services';
import { useSnackbar } from 'notistack';
import ConfirmDialog from 'app/shared/widgets/ConfirmDialog';

const GOOGLE_MAPS_LIBS = ["visualization", "places", "drawing"]
const TRIP_MANAGEMENT_PROFILE_NAMES = ['customer_admin', 'planner', 'supervisor'];

// https://loading.io/icon/set/thjmhy-map-marker


const RouteBuilder = props => {
    const { authUser } = useContext(AuthContext);
    const { enqueueSnackbar } = useSnackbar();
    const [newDeliveries, setNewDeliveries] = useState([])
    const [deliveriesLoading, setDeliveriesLoading] = useState(false)
    const [routeLoading, setRouteLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [hoveredMarker, setHoveredMarker] = useState(null)
    const [reloadOnClose, setReloadOnClose] = useState(false)
    const [originLoc, setOriginLoc] = useState(null)
    // Bodega donde cierra el viaje, y SOLO cuando no es la de salida: el backend manda
    // null en cualquier otro caso (ver Trip#routing_destination_centre). O sea que con
    // esto puesto ya esta decidido que corresponde dibujar la bandera; aca no se vuelve
    // a evaluar la regla.
    const [destinationLoc, setDestinationLoc] = useState(null)
    const [destinationName, setDestinationName] = useState(null)
    const [mapCenter, setMapCenter] = useState({
        lat: -33.51392,
        lng: -70.73039,
    })
    const [selectedDelivery, setSelectedDelivery] = useState(null)
    const [canSave, setCanSave] = useState(false)
    // Modo de reordenamiento manual. Apagado por defecto: la lista tambien se usa para mirar y
    // para abrir cada entrega, y con el arrastre siempre vivo bastaba un click con el mouse en
    // movimiento para cambiar el orden del viaje sin querer.
    const [sortMode, setSortMode] = useState(false)
    // Modo seleccion, para eliminar varias entregas de una sola vez. Es excluyente con
    // el de ordenar: en la misma lista, un arrastre y un click-para-marcar se pisan.
    const [selectMode, setSelectMode] = useState(false)
    const [selectedForRemoval, setSelectedForRemoval] = useState([])
    const [confirmBulkRemove, setConfirmBulkRemove] = useState(false)
    const [bulkRemoving, setBulkRemoving] = useState(false)
    const [confirmDeleteTrip, setConfirmDeleteTrip] = useState(false)
    const [deletingTrip, setDeletingTrip] = useState(false)
    // Los dos estados en los que el viaje todavia se esta armando y nadie salio a la ruta. En
    // `in_progress` el chofer ya tiene el orden en su app y quedaria mirando otro distinto del
    // guardado; en `finished` no hay nada que reordenar.
    const canReorderTrip = _.includes(['planned', 'pending'], props.trip?.state)
    const [mapPickupMode, setMapPickupMode] = useState(null)
    // La instancia del mapa. Hace falta para encuadrar los puntos de retiro: el zoom va
    // como prop fija en 10 —nivel ciudad— y con eso las agencias quedaban como chinches
    // minusculas y desperdigadas, sin forma de distinguir cual clickear.
    const mapRef = useRef(null)
    const [pickupPoints, setPickupPoints] = useState([])
    const [loadingPickupPoints, setLoadingPickupPoints] = useState(false)
    const [selectedPickupPoint, setSelectedPickupPoint] = useState(null)
    const [routePreviewPaths, setRoutePreviewPaths] = useState([])
    // Resumen de la ruta que se esta armando: km, duracion y costo estimado. Viene de
    // la misma llamada que ya trae el trazado, asi que no cuesta una transaccion extra.
    const [routePreview, setRoutePreview] = useState(null)
    // La comparacion de peajes se guarda en el viaje, pero sus numeros dependen del
    // ORDEN de las paradas. Leerla siempre de props.trip dejaba en pantalla los de la
    // ultima vez que se trazo la ruta, aunque Optimizar hubiera cambiado el recorrido.
    // Se siembra del viaje al abrir y se refresca con lo que devuelve Optimizar.
    const [tollComparison, setTollComparison] = useState(null)
    // El orden que devolvio la ultima optimizacion, para no repetir la llamada a HERE
    // si nadie movio nada. Es null mientras no se haya optimizado en esta sesion del
    // dialogo: no se puede saber si el orden guardado vino de una optimizacion o de un
    // arrastre manual, asi que la primera vez siempre se deja pasar.
    const [optimizedSignature, setOptimizedSignature] = useState(null)
    // Se cambio la direccion de una parada desde su icono de mapa: el orden y la ruta
    // quedaron armados para el lugar anterior, asi que se avisa hasta que se optimice.
    const [stopAddressChanged, setStopAddressChanged] = useState(false)
    const pickupSearchRequestRef = useRef(0);
    const pickupSearchGeocoderRef = useRef(null);
    const pickupModeRef = useRef(null);
    const {isLoaded} = useLoadScript({
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries: GOOGLE_MAPS_LIBS
    });
    const currentCompanyId = authUser?.current_company?.id;
    const profileNames = Array.isArray(authUser?.profiles)
        ? authUser.profiles.map((profile) => profile?.name).filter(Boolean)
        : [];
    const currentCompanyProfileNames = Array.isArray(authUser?.profiles)
        ? authUser.profiles
            .filter((profile) => profile?.company_id === currentCompanyId)
            .map((profile) => profile?.name)
            .filter(Boolean)
        : [];
    const canManageTrip = profileNames.includes('superadmin') ||
        currentCompanyProfileNames.some((profileName) => TRIP_MANAGEMENT_PROFILE_NAMES.includes(profileName));

    const optionsPoly = {
        strokeColor: "#1867D2",
        fillColor: "#02B0FF",        
        strokeOpacity: 0.8,
        strokeWeight: 4,
        fillOpacity: 1,
        clickable: false,
        draggable: false,
        editable: false,
        visible: true,
        radius: 30000,
        zIndex: 1
    };

    const getDropoffIcon = (delivery) => {
        const pointFactory = window.google?.maps?.Point
            ? (x, y) => new window.google.maps.Point(x, y)
            : undefined;

        return getDropoffMarkerStyle({
            carrier: delivery?.dropoff_carrier || delivery?.order?.dropoff_carrier,
            state: delivery?.state,
            pointFactory,
        });
    };

    const normalizePickupPoint = useCallback((point, fallbackCarrier = null) => {
        if (!point) return null;

        return {
            id: point.id || `${point.lat}-${point.lng}-${point.carrier || fallbackCarrier || 'dropoff'}`,
            name: point.name || 'Punto de dropoff',
            lat: point.lat,
            lng: point.lng,
            carrier: point.carrier || fallbackCarrier,
            address_hint: point.address_hint || '',
        };
    }, []);

    const getPickupSearchGeocoder = useCallback(() => {
        if (pickupSearchGeocoderRef.current) return pickupSearchGeocoderRef.current;

        const GeocoderCtor = window?.google?.maps?.Geocoder;
        if (!GeocoderCtor) return null;

        pickupSearchGeocoderRef.current = new GeocoderCtor();
        return pickupSearchGeocoderRef.current;
    }, []);

    const geocodePickupSearchAddress = useCallback(async ({ address, carrier }) => {
        const normalizedAddress = String(address || '').trim();
        if (!normalizedAddress) return null;

        const geocoder = getPickupSearchGeocoder();
        if (!geocoder) return null;

        return new Promise((resolve) => {
            geocoder.geocode(
                {
                    address: normalizedAddress,
                    componentRestrictions: { country: 'CL' },
                    region: 'CL',
                },
                (results, status) => {
                    const okStatus = window?.google?.maps?.GeocoderStatus?.OK || 'OK';
                    if (status !== okStatus || !results?.length) {
                        resolve(null);
                        return;
                    }

                    const location = results[0]?.geometry?.location;
                    const lat = typeof location?.lat === 'function' ? location.lat() : null;
                    const lng = typeof location?.lng === 'function' ? location.lng() : null;

                    if (!_.isFinite(lat) || !_.isFinite(lng)) {
                        resolve(null);
                        return;
                    }

                    resolve({
                        id: `pickup_search_${carrier || 'carrier'}_${Date.now()}`,
                        name: 'Direccion buscada (estimado)',
                        lat,
                        lng,
                        carrier,
                        address_hint: results[0]?.formatted_address || normalizedAddress,
                    });
                }
            );
        });
    }, [getPickupSearchGeocoder]);

    const clearPickupMode = useCallback(() => {
        pickupSearchRequestRef.current += 1;
        pickupModeRef.current = null;
        setMapPickupMode(null);
        setPickupPoints([]);
        setLoadingPickupPoints(false);
        setSelectedPickupPoint(null);
    }, []);

    const handleDropoffMapContextChange = useCallback((nextMode) => {
        if (!nextMode?.carrier || !nextMode?.contextId) {
            clearPickupMode();
            return;
        }

        const normalizedSelectedPoint = normalizePickupPoint(nextMode.selectedPoint, nextMode.carrier);
        const previousMode = pickupModeRef.current;
        const shouldResetSearch = (
            previousMode?.contextId !== nextMode.contextId ||
            previousMode?.carrier !== nextMode.carrier
        );

        const normalizedMode = {
            ...nextMode,
            selectedPoint: normalizedSelectedPoint,
        };

        pickupModeRef.current = normalizedMode;
        setMapPickupMode(normalizedMode);

        if (shouldResetSearch) {
            pickupSearchRequestRef.current += 1;
            setLoadingPickupPoints(false);
            setPickupPoints(normalizedSelectedPoint ? [normalizedSelectedPoint] : []);
            setSelectedPickupPoint(normalizedSelectedPoint || null);
        } else if (normalizedSelectedPoint) {
            setSelectedPickupPoint(normalizedSelectedPoint);
            setPickupPoints((currentPoints) => {
                const remainingPoints = currentPoints.filter((point) => `${point.id}` !== `${normalizedSelectedPoint.id}`);
                return [normalizedSelectedPoint, ...remainingPoints];
            });
        }

        if (normalizedSelectedPoint?.lat && normalizedSelectedPoint?.lng) {
            setMapCenter({
                lat: _.toNumber(normalizedSelectedPoint.lat),
                lng: _.toNumber(normalizedSelectedPoint.lng),
            });
        }
    }, [clearPickupMode, normalizePickupPoint]);

    /**
     * Deja los puntos de retiro encuadrados en el mapa.
     *
     * Con varios se usa `fitBounds`, que ajusta centro y zoom para que entren todos; con uno
     * solo `fitBounds` se iria al zoom maximo y quedaria pegado al techo, asi que se centra
     * a mano en un nivel de calle.
     *
     * Es imperativo sobre la instancia y no por props porque `zoom` esta fijo en el JSX:
     * cambiarlo a estado obligaria a manejar el zoom de todo lo demas que dibuja el mapa.
     * `setMapCenter` va igual al final para que el estado no quede diciendo otra cosa; como
     * apunta a donde el encuadre ya dejo el mapa, no lo mueve.
     */
    const focusPickupPoints = useCallback((points) => {
        const coords = (points || [])
            .map((point) => ({lat: _.toNumber(point.lat), lng: _.toNumber(point.lng)}))
            .filter((coord) => _.isFinite(coord.lat) && _.isFinite(coord.lng));

        if (coords.length === 0) return;

        const map = mapRef.current;

        if (coords.length === 1 || !map || !window?.google?.maps?.LatLngBounds) {
            if (map && coords.length === 1) {
                map.setCenter(coords[0]);
                map.setZoom(15);
            }
            setMapCenter(coords[0]);
            return;
        }

        const bounds = new window.google.maps.LatLngBounds();
        coords.forEach((coord) => bounds.extend(coord));
        // Margen para que los pines de los extremos no queden mordidos por el borde.
        map.fitBounds(bounds, 48);

        const center = bounds.getCenter();
        setMapCenter({lat: center.lat(), lng: center.lng()});
    }, []);

    const handlePickupSearch = useCallback(async (address, options = {}) => {
        const { notify = false } = options;
        const selectedCarrier = pickupModeRef.current?.carrier;
        if (!selectedCarrier) return;

        const requestId = pickupSearchRequestRef.current + 1;
        pickupSearchRequestRef.current = requestId;
        setLoadingPickupPoints(true);

        try {
            const data = await shippingServices.getShippingPoints({
                carrier: selectedCarrier,
                address,
            });

            if (requestId !== pickupSearchRequestRef.current) return;

            const points = data?.points || [];
            const source = data?.source;
            const isFakeSource = source === 'fallback_fake' || source === 'fake';
            let pointsToDisplay = points.slice(0, 20).map((point) => normalizePickupPoint(point, selectedCarrier));

            if (isFakeSource) {
                const searchedAddressPoint = await geocodePickupSearchAddress({
                    address,
                    carrier: selectedCarrier,
                });

                if (requestId !== pickupSearchRequestRef.current) return;

                if (searchedAddressPoint) {
                    pointsToDisplay = [normalizePickupPoint(searchedAddressPoint, selectedCarrier)];
                } else {
                    pointsToDisplay = points.slice(0, 1).map((point) => normalizePickupPoint({
                        ...point,
                        address_hint: address,
                    }, selectedCarrier));
                }
            }

            focusPickupPoints(pointsToDisplay);
            setPickupPoints(pointsToDisplay);

            if (notify && isFakeSource) {
                enqueueSnackbar(
                    `Se esta mostrando un punto estimado de ${selectedCarrier} porque la API no esta disponible.`,
                    { variant: 'warning' }
                );
            } else if (notify && pointsToDisplay.length > 0) {
                enqueueSnackbar(
                    `Se cargaron ${pointsToDisplay.length} puntos de ${selectedCarrier} en el mapa.`,
                    { variant: 'success' }
                );
            }

            if (notify && pointsToDisplay.length === 0) {
                enqueueSnackbar(
                    `No se encontraron puntos para "${address}".`,
                    { variant: 'info' }
                );
            }
        } catch (error) {
            console.error('Error buscando puntos de carrier:', error);
            if (requestId !== pickupSearchRequestRef.current) return;

            setPickupPoints(selectedPickupPoint ? [selectedPickupPoint] : []);

            if (notify) {
                enqueueSnackbar(
                    'No se pudo consultar puntos de retiro. Intenta nuevamente.',
                    { variant: 'error' }
                );
            }
        } finally {
            if (requestId === pickupSearchRequestRef.current) {
                setLoadingPickupPoints(false);
            }
        }
    }, [enqueueSnackbar, focusPickupPoints, geocodePickupSearchAddress, normalizePickupPoint, selectedPickupPoint]);

    const handlePickupPointClick = useCallback((point) => {
        const selectedPoint = normalizePickupPoint(point, pickupModeRef.current?.carrier);
        if (!selectedPoint) return;

        setSelectedPickupPoint(selectedPoint);
        setPickupPoints((currentPoints) => {
            const remainingPoints = currentPoints.filter((currentPoint) => `${currentPoint.id}` !== `${selectedPoint.id}`);
            return [selectedPoint, ...remainingPoints];
        });
        setMapCenter({
            lat: _.toNumber(selectedPoint.lat),
            lng: _.toNumber(selectedPoint.lng),
        });

        if (pickupModeRef.current) {
            const nextMode = {
                ...pickupModeRef.current,
                selectedPoint,
            };
            pickupModeRef.current = nextMode;
            setMapPickupMode(nextMode);
        }

        enqueueSnackbar('Punto de dropoff seleccionado en el mapa.', { variant: 'success' });
    }, [enqueueSnackbar, normalizePickupPoint]);

    useEffect(() => {
        pickupModeRef.current = mapPickupMode;
    }, [mapPickupMode]);

    const tripCentreId = props.trip?.centre?.id || props.trip?.vehicle?.centre_id;

    const buildRoutePreviewOrder = useCallback((delivery) => ({
        id: delivery?.order?.id,
        code: delivery?.order?.code,
        dropoff: Boolean(delivery?.dropoff ?? delivery?.order?.dropoff),
        dropoff_point: delivery?.dropoff_point || delivery?.order?.dropoff_point || null,
        locatable: {
            // El tipo y el id de la direccion, no solo sus coordenadas: con ellos el
            // backend usa el tiempo de servicio aprendido de esa misma direccion, que
            // es el que despues va a usar el viaje. Sin mandarlos la previa caia
            // siempre en los 30 minutos por defecto y mostraba una duracion y un
            // costo distintos a los del viaje de verdad.
            type: delivery?.locatable?.type,
            id: delivery?.locatable?.id,
            location: {
                lat: deliveryLocation(delivery)?.lat,
                lng: deliveryLocation(delivery)?.lng,
            }
        }
    }), []);

    const refreshRoutePreview = useCallback(async () => {
        if (!tripCentreId || newDeliveries.length === 0) {
            setRoutePreviewPaths([]);
            return;
        }

        try {
            const data = await tripServices.calculateRoutes({
                centre_id: tripCentreId,
                trips: [
                    {
                        // El backend mira el vehiculo para saber si esquiva peajes.
                        vehicle_id: props.trip?.vehicle?.id ?? null,
                        orders: newDeliveries.map(buildRoutePreviewOrder)
                    }
                ]
            });

            const calculatedTrip = Array.isArray(data) ? data[0] : null;
            if (calculatedTrip?.error) {
                setRoutePreviewPaths([]);
                setRoutePreview(null);
                return;
            }

            setRoutePreviewPaths(calculatedTrip?.paths || []);
            setRoutePreview(calculatedTrip || null);
        } catch (error) {
            console.error('Error recalculando rutas del instructivo:', error);
            setRoutePreviewPaths([]);
            setRoutePreview(null);
        }
    }, [buildRoutePreviewOrder, newDeliveries, tripCentreId, props.trip?.vehicle?.id]);

    const loadDetails = useCallback(() => {
        setDeliveriesLoading(true);
        tripServices.getTripDetails(props.trip?.id, '?with_routes=true&include=deliveries.receipt,deliveries.survey_answers,deliveries.order,deliveries.docs_images_attachments,deliveries.shipping_docs.shipping_doc_kind,deliveries.locatable.location,deliveries.locatable.recipients,deliveries.delivery_details.images_attachments,deliveries.delivery_details.order_detail')
            .then((data) => {
                setNewDeliveries(data?.deliveries)
                setOriginLoc(data?.origin_location)
                setDestinationLoc(data?.destination_location || null)
                setDestinationName(data?.destination_centre_name || null)
                if(data?.origin_location) {
                    setMapCenter({
                        lat: data.origin_location.lat,
                        lng: data.origin_location.lng
                    })
                } else {
                    const firstDestination = (data?.deliveries || [])
                        .map((delivery) => getDeliveryDestination(delivery))
                        .find((destination) => destination !== null);

                    if (firstDestination) {
                        setMapCenter({
                            lat: firstDestination.lat,
                            lng: firstDestination.lng
                        });
                    }
                }
                setDeliveriesLoading(false);
            });
    }, [props.trip])

    useEffect(() => {
        if(props.trip) {
            loadDetails()
        }
    }, [loadDetails, props.trip])

    useEffect(() => {
        setTollComparison(props.trip?.toll_comparison || null)
        setOptimizedSignature(null)
        // El modo seleccion no sobrevive al cambio de viaje: los ids marcados son de
        // las entregas del viaje anterior y no significan nada en el nuevo.
        setSelectMode(false)
        setSelectedForRemoval([])
    }, [props.trip])

    useEffect(() => {
        refreshRoutePreview();
    }, [refreshRoutePreview]);

    // Resumen de lo que se esta armando, encima del mapa. El punto es que el numero
    // aparezca ANTES de aceptar el viaje, que es cuando todavia se puede cambiar.
    // Que se paga por esquivar los peajes, en kilometros, minutos y plata.
    //
    // Va bajo el mapa y no en la tarjeta del listado: aca es donde se arma el viaje
    // y todavia se puede cambiar de opinion. En el listado era un numero mas entre
    // varios que nadie estaba mirando.
    const renderTollComparison = () => {
        const c = tollComparison;
        if (!c?.delta) return null;

        const d = c.delta;
        const evitando = c.used === 'avoid';
        const km = Math.abs(d.extra_distance_m / 1000);
        const min = Math.abs(Math.round(d.extra_duration_s / 60));
        const masCorto = d.extra_distance_m < 0;
        const masRapido = d.extra_duration_s < 0;
        const moneda = c.avoid?.currency || c.allow?.currency || 'CLP';

        return (
            <Div sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mt: 1.5, px: 1.5, py: 1, borderRadius: 2, bgcolor: 'action.hover' }}>
                <TollOutlinedIcon fontSize="small" color="primary" sx={{ mt: 0.3 }} />
                <Div>
                    <Typography variant="body2" color="text.secondary">
                        {evitando ? 'Este vehículo evita peajes' : 'Este vehículo usa autopistas'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                        {`Sin autopistas: ${masCorto ? '−' : '+'}${km.toLocaleString('es-CL', { maximumFractionDigits: 1 })} km, ${masRapido ? '−' : '+'}${min} min`}
                        {d.toll_saved
                            ? ` · ahorra ${Number(d.toll_saved).toLocaleString('es-CL', { maximumFractionDigits: 0 })} ${moneda} en peajes`
                            : ''}
                    </Typography>
                </Div>
            </Div>
        );
    };

    // Si el viaje cabe en la bateria. No es un costo: un viaje que no cabe no sale
    // mas caro, sale imposible, y eso hay que verlo ACA —armando— y no en la calle.
    const renderEnergyPlan = () => {
        const e = props.trip?.energy_plan;
        if (!e || e.fits_range === undefined || e.fits_range === null) return null;

        const cabe = e.fits_range === true;
        const num = (v) => Number(v).toLocaleString('es-CL', { maximumFractionDigits: 1 });

        return (
            <Div sx={{ display: 'flex', alignItems: 'flex-start', gap: 1, mt: 1.5, px: 1.5, py: 1, borderRadius: 2, bgcolor: 'action.hover' }}>
                <BatteryCharging90OutlinedIcon fontSize="small" color={cabe ? 'primary' : 'error'} sx={{ mt: 0.3 }} />
                <Div>
                    <Typography variant="body2" color={cabe ? 'text.secondary' : 'error.main'}>
                        {cabe ? 'El viaje cabe en la batería' : 'El viaje NO cabe en la batería'}
                    </Typography>
                    <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                        {`Necesita ${num(e.needed_kwh)} kWh · disponibles ${num(e.available_kwh)} de ${num(e.usable_kwh)} útiles (${num(e.reserve_pct)}% de reserva)`}
                        {cabe
                            ? ` · sobran ${num(e.headroom_kwh)} kWh`
                            : ` · faltan ${num(Math.abs(Number(e.headroom_kwh)))} kWh`}
                    </Typography>
                </Div>
            </Div>
        );
    };

    const renderRoutePreviewSummary = () => {
        if (!routePreview?.distance_m) return null;

        const km = (routePreview.distance_m / 1000).toLocaleString('es-CL', { maximumFractionDigits: 1 });
        // El backend manda este campo como `duration`, en segundos. Leerlo como
        // `duration_s` daba undefined y la pantalla mostraba "NaNm".
        const segundos = Number(routePreview.duration);
        const duracion = Number.isFinite(segundos) && segundos > 0
            ? (segundos >= 3600
                ? `${Math.floor(segundos / 3600)}h ${Math.round((segundos % 3600) / 60)}m`
                : `${Math.round(segundos / 60)}m`)
            : null;
        const costo = routePreview.cost || {};
        const moneda = costo.currency || 'CLP';
        const monto = (v) => Number(v).toLocaleString('es-CL', { maximumFractionDigits: 0 });

        return (
            <Div sx={{
                display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 2,
                px: 1.5, py: 1, mb: 1, borderRadius: 2, bgcolor: 'action.hover',
            }}>
                <Typography variant="body2" color="text.secondary">
                    <strong>{km} km</strong>{duracion ? ` · ${duracion}` : ''}
                </Typography>

                {routePreview.return_distance_m > 0 && (
                    <Tooltip title="Kilometraje del regreso a la bodega, incluido en el total">
                        <Typography variant="body2" color="text.secondary">
                            ↩ {(routePreview.return_distance_m / 1000).toLocaleString('es-CL', { maximumFractionDigits: 1 })} km de regreso
                        </Typography>
                    </Tooltip>
                )}

                {routePreview.service_time_s > 0 && (
                    <Tooltip title="Tiempo estimado en las paradas, ya incluido en la duración">
                        <Typography variant="body2" color="text.secondary">
                            {Math.round(routePreview.service_time_s / 60)} min en paradas
                        </Typography>
                    </Tooltip>
                )}

                {costo.total && (
                    <Tooltip title={[
                        costo.fuel ? `Combustible: ${monto(costo.fuel)} ${moneda}` : null,
                        costo.driver ? `Chofer: ${monto(costo.driver)} ${moneda}` : null,
                        costo.toll ? `Peajes: ${monto(costo.toll)} ${moneda}` : null,
                        costo.incomplete_reason,
                    ].filter(Boolean).join(' · ')}>
                        <Typography variant="body2" color="primary" sx={{ fontWeight: 500 }}>
                            {monto(costo.total)} {moneda}
                        </Typography>
                    </Tooltip>
                )}
            </Div>
        );
    };

    /**
     * Aviso sobre el borde inferior del mapa mientras se esta eligiendo un punto de retiro.
     *
     * Va encima del mapa y no debajo del formulario porque la accion que pide —clickear un
     * pin— pasa en el mapa, y ahi es donde esta mirando quien planifica.
     */
    const renderPickupHint = () => {
        if (!mapPickupMode?.carrier) return null;

        const hint = loadingPickupPoints
            ? {text: 'Buscando puntos…', bg: 'rgba(38, 50, 56, 0.88)'}
            : selectedPickupPoint
                ? {
                    text: `Punto elegido: ${_.compact([selectedPickupPoint.name, selectedPickupPoint.address_hint]).join(' - ')}`,
                    bg: 'rgba(46, 158, 91, 0.94)',
                }
                : pickupPoints.length > 0
                    ? {text: 'Selecciona el punto de dropoff correspondiente', bg: 'rgba(21, 101, 192, 0.94)'}
                    : {text: 'Busca la dirección para cargar los puntos de dropoff', bg: 'rgba(38, 50, 56, 0.88)'};

        return (
            <Div
                sx={{
                    position: 'absolute',
                    left: '50%',
                    bottom: 88,
                    transform: 'translateX(-50%)',
                    maxWidth: 'calc(100% - 96px)',
                    px: 2,
                    py: 0.75,
                    borderRadius: 5,
                    backgroundColor: hint.bg,
                    // Por encima de los controles de Google, que se plantan en z-index 1.
                    zIndex: 2,
                    pointerEvents: 'none',
                    boxShadow: '0 2px 10px rgba(0,0,0,0.35)',
                }}>
                <Typography variant="caption" sx={{color: '#fff', fontWeight: 600, display: 'block', textAlign: 'center'}}>
                    {hint.text}
                </Typography>
            </Div>
        );
    };

    // Lo que se ve al pasar el mouse por un pincho. Mismo formato que la fila de la lista
    // ("viaje - entrega (P: pedido)" + cliente) para que se encuentren a simple vista.
    const deliveryTooltipLines = (delivery) => {
        const orderCode = delivery?.order?.code ? ` (P: ${delivery.order.code})` : '';
        const customer = [delivery?.locatable?.code, delivery?.locatable?.name].filter(Boolean).join(' ');
        const head = `${props.trip?.id ? `${props.trip.id} - ` : ''}${delivery?.code}${orderCode}`;
        return { head, customer };
    };

    const stopTooltipTitle = (stopNumber, destination, deliveries) => {
        const dropoffPoint = deliveries[0]?.dropoff_point || deliveries[0]?.order?.dropoff_point;
        const header = destination.isDropoff
            ? `Parada ${stopNumber} · Dropoff${dropoffPoint?.name ? `: ${dropoffPoint.name}` : ''}`
            : `Parada ${stopNumber}`;
        const count = deliveries.length > 1 ? ` (${deliveries.length} entregas)` : '';
        return `${header}${count}`;
    };

    const markerHoverHandlers = (marker) => ({
        onMouseOver: () => setHoveredMarker(marker),
        onMouseOut: () => setHoveredMarker(null),
    });

    const renderMarkerTooltip = () => {
        if (!hoveredMarker) return null;
        const offsetFactory = window.google?.maps?.Size
            ? (w, h) => new window.google.maps.Size(w, h)
            : null;

        return (
            <InfoWindow
                position={hoveredMarker.position}
                options={{
                    // Se abre sobre el pincho y no encima de la punta, que es donde apunta la posición.
                    pixelOffset: offsetFactory ? offsetFactory(0, -38) : undefined,
                    disableAutoPan: true,
                    headerDisabled: true,
                }}
            >
                <Div sx={{maxWidth: 320, pr: 0.5}}>
                    <Typography variant="body1" fontWeight={600} mb={0.5}>{hoveredMarker.title}</Typography>
                    {hoveredMarker.deliveries.map((delivery) => {
                        const { head, customer } = deliveryTooltipLines(delivery);
                        return (
                            <Div key={delivery.id} sx={{mt: 0.75}}>
                                <Typography variant="body2" mb={0}>{head}</Typography>
                                {customer && (
                                    <Typography variant="body2" color="text.secondary" mb={0}>{customer}</Typography>
                                )}
                            </Div>
                        );
                    })}
                </Div>
            </InfoWindow>
        );
    };

    const renderMap = () => {
        // Las entregas seguidas que van al mismo destino (misma dirección o mismo punto de
        // dropoff) comparten parada y un solo pincho, así que se agrupan antes de pintar.
        // El numero sale del mismo calculo que la lista, para que el pincho y la fila digan lo mismo.
        const stopNumbers = stopNumbersByDeliveryId(newDeliveries);
        const stops = [];
        _.forEach(newDeliveries, (nd) => {
            const destination = getDeliveryDestination(nd);
            if (!destination) return;
            const lastStop = _.last(stops);
            if (lastStop?.destination.key === destination.key) {
                lastStop.deliveries.push(nd);
            } else {
                stops.push({ number: stopNumbers[nd.id], destination, deliveries: [nd] });
            }
        });
        const lastPos = props.trip?.last_position;
        const hasDestinations = newDeliveries.some((delivery) => getDeliveryDestination(delivery));
        const hasPickupPoints = pickupPoints.length > 0;
        const hasMapContent = Boolean(originLoc || destinationLoc || hasDestinations || hasPickupPoints || mapPickupMode);
        const hasPreviewRoute = routePreviewPaths.length > 0;

        return (
            <React.Fragment>
                {renderRoutePreviewSummary()}
                {isLoaded && hasMapContent && (
                    <Div sx={{position: 'relative', height: '100%'}}>
                    <GoogleMap
                        mapContainerStyle={{ width: '100%', minHeight: 400, height: "100%", borderRadius: 12 }}
                        center={mapCenter}
                        zoom={10}
                        onLoad={(map) => { mapRef.current = map; }}
                        onUnmount={() => { mapRef.current = null; }}
                    >
                        {/* === Polígonos de clientes === */}
                        {_.map(newDeliveries, (nd) => (
                            deliveryLocation(nd)?.path ? (
                                <Polygon
                                    path={geoCoords(deliveryLocation(nd)?.path)}
                                    key={nd.code}
                                    options={{
                                        strokeColor: "#FF0000",
                                        strokeOpacity: 0.8,
                                        strokeWeight: 2,
                                        fillColor: "#FF0000",
                                        fillOpacity: 0.35,
                                    }}
                                />
                            ) : null
                        ))}

                        {/* === Origen === */}
                        {originLoc && (
                            <Marker
                                icon={getAssetPath(`${ASSET_IMAGES}/map-markers/base.png`)}
                                position={{ lat: originLoc.lat, lng: originLoc.lng }}
                            />
                        )}

                        {/* === Llegada ===
                            Bandera en la bodega donde cierra el viaje, tambien cuando vuelve
                            a la de salida: asi siempre se ve donde termina. Va encima del
                            marcador de origen (zIndex). La decision la toma el backend, que
                            manda `destination_location` en null solo con la ruta abierta. */}
                        {destinationLoc?.lat && destinationLoc?.lng && (
                            <Marker
                                icon={getFinishMarkerIcon({
                                    sizeFactory: window.google?.maps?.Size
                                        ? (w, h) => new window.google.maps.Size(w, h)
                                        : undefined,
                                    pointFactory: window.google?.maps?.Point
                                        ? (x, y) => new window.google.maps.Point(x, y)
                                        : undefined,
                                })}
                                position={{ lat: destinationLoc.lat, lng: destinationLoc.lng }}
                                title={destinationName ? `Llegada: ${destinationName}` : 'Llegada'}
                                zIndex={1000}
                            />
                        )}

                        {/* === Entregas y rutas === */}
                        {_.map(stops, ({ number, destination, deliveries }) => {
                            const nd = deliveries[0];
                            const position = { lat: destination.lat, lng: destination.lng };
                            const hoverHandlers = markerHoverHandlers({
                                position,
                                title: stopTooltipTitle(number, destination, deliveries),
                                deliveries,
                            });
                            return (
                                <React.Fragment key={nd.id}>
                                    {destination.isDropoff ? (
                                        <Marker
                                            position={position}
                                            icon={getDropoffIcon(nd)}
                                            {...hoverHandlers}
                                            label={{
                                                text: `${number}`,
                                                color: 'white',
                                                textAlign: 'center',
                                                fontWeight: 'bold',
                                                anchor: { x: 0, y: 40 },
                                            }}
                                            zIndex={120}
                                        />
                                    ) : (
                                        <CustomMarker
                                            id={nd.id}
                                            lat={destination.lat}
                                            lng={destination.lng}
                                            kind={nd.state}
                                            {...hoverHandlers}
                                            label={{
                                                text: `${number}`,
                                                color: 'white',
                                                textAlign: 'center',
                                                fontWeight: 'bold',
                                                anchor: { x: 0, y: 40 },
                                            }}
                                            zIndex={100}
                                        />
                                    )}
                                    {!hasPreviewRoute && nd.route_path?.length > 0 && (
                                        <Polyline path={nd.route_path} options={optionsPoly} />
                                    )}
                                    {nd.receipt?.lat && nd.receipt?.lng && (
                                        <Marker
                                            {...markerHoverHandlers({
                                                position: {
                                                    lat: _.toNumber(nd.receipt.lat),
                                                    lng: _.toNumber(nd.receipt.lng),
                                                },
                                                title: `Parada ${number} · posición real de entrega`,
                                                deliveries: [nd],
                                            })}
                                            label={{
                                                text: `${number}`,
                                                color: 'white',
                                                textAlign: 'center',
                                                fontWeight: 'bold',
                                                anchor: { x: 10, y: 40 },
                                            }}
                                            position={{
                                                lat: _.toNumber(nd.receipt.lat),
                                                lng: _.toNumber(nd.receipt.lng),
                                            }}
                                        />
                                    )}
                                </React.Fragment>
                            );
                        })}

                        {pickupPoints.map((point) => {
                            const isSelectedPoint = `${selectedPickupPoint?.id}` === `${point.id}`;
                            return (
                                <Marker
                                    key={`pickup_${point.id}`}
                                    position={{
                                        lat: _.toNumber(point.lat),
                                        lng: _.toNumber(point.lng),
                                    }}
                                    icon={{
                                        path: window.google.maps.SymbolPath.CIRCLE,
                                        scale: isSelectedPoint ? 9 : 7,
                                        fillColor: getCarrierMarkerColor(point.carrier),
                                        fillOpacity: 1,
                                        strokeColor: '#ffffff',
                                        strokeWeight: 2,
                                    }}
                                    zIndex={isSelectedPoint ? 150 : 140}
                                    onClick={() => handlePickupPointClick(point)}
                                />
                            );
                        })}

                        {renderMarkerTooltip()}

                        {hasPreviewRoute && routePreviewPaths.map((path, index) => (
                            <Polyline
                                key={`preview_route_${index}`}
                                path={path}
                                options={optionsPoly}
                            />
                        ))}

                        {/* === Marker del camión (última posición real) === */}

                        {lastPos?.lat && lastPos?.lng && (
                            <TruckMarker
                                lat={lastPos.lat}
                                lng={lastPos.lng}
                                heading={lastPos.heading}
                                ppu={lastPos.ppu}
                            />
                        )}



                    </GoogleMap>
                    {renderPickupHint()}
                    </Div>
                )}
                {renderTollComparison()}
                {renderEnergyPlan()}
            </React.Fragment>
        );
    };

    // Los mismos includes con los que se carga el instructivo. Sin ellos la respuesta
    // llega sin `deliveries` y no hay nada que aplicar: el backend reordena bien y el
    // orden nuevo se pierde en el camino.
    const signatureOf = (list) => (list || []).map((d) => d.id).join(',');

    // Con el viaje EN CURSO no se bloquea aunque el orden sea el mismo: la
    // reoptimizacion arranca desde la posicion del camion, que se movio, asi que la
    // misma lista de paradas puede dar un orden distinto.
    const enRuta = props.trip?.state === 'in_progress';
    const sinCambiosQueOptimizar =
        !enRuta && optimizedSignature !== null && signatureOf(newDeliveries) === optimizedSignature;

    const ROUTE_ORDER_INCLUDE =
        'deliveries.receipt,deliveries.survey_answers,deliveries.order,' +
        'deliveries.docs_images_attachments,deliveries.shipping_docs.shipping_doc_kind,' +
        'deliveries.locatable.location,deliveries.locatable.recipients,' +
        'deliveries.delivery_details.images_attachments,deliveries.delivery_details.order_detail';

    const calculateRoute = () => {
        setRouteLoading(true)
        tripServices.calculateRouteOrder(props.trip?.id, { include: ROUTE_ORDER_INCLUDE })
                .then((data) => {
                    // Centrar el mapa es opcional; aplicar el orden no. Estaban al
                    // reves: si `origin_location` no venia en la respuesta, la
                    // excepcion saltaba ANTES de setNewDeliveries y el orden
                    // optimizado se perdia sin que nada lo dijera.
                    if (data?.origin_location?.lat && data?.origin_location?.lng) {
                        setMapCenter({ lat: data.origin_location.lat, lng: data.origin_location.lng })
                    }
                    // Optimizar devuelve el viaje completo: si no se refrescan aca, la
                    // bandera desaparece del mapa al optimizar y vuelve recien al reabrir.
                    setDestinationLoc(data?.destination_location || null)
                    setDestinationName(data?.destination_centre_name || null)
                    // El backend rehace la comparacion con el orden nuevo; sin esto
                    // la pantalla seguiria mostrando los kilometros del orden viejo.
                    if (data?.toll_comparison !== undefined) {
                        setTollComparison(data.toll_comparison)
                    }
                    if (data?.deliveries) {
                        setNewDeliveries(data.deliveries)
                        setOptimizedSignature(signatureOf(data.deliveries))
                        setStopAddressChanged(false)
                    } else {
                        // No deberia pasar, pero si pasa es exactamente el sintoma de
                        // "el boton no hace nada": mejor decirlo que quedarse mudo.
                        enqueueSnackbar('El servidor no devolvió las paradas reordenadas', { variant: 'warning' });
                    }
                    setRouteLoading(false)
                })
                .catch((err) => {
                    // 409 con already_optimized: el backend no repite la optimizacion con las
                    // mismas paradas, porque consume saldo de HERE. No es un error: se avisa en
                    // amarillo y el orden que ya estaba sigue valido.
                    if (err?.response?.status === 409 && err?.response?.data?.already_optimized) {
                        enqueueSnackbar(err.response.data.error, { variant: 'warning' });
                        setRouteLoading(false)
                        return;
                    }
                    // Un catch mudo convierte cualquier fallo en "no pasa nada".
                    console.error('Error optimizando el orden de las paradas:', err);
                    enqueueSnackbar(
                        err?.response?.data?.error || 'No se pudo optimizar el orden de las paradas',
                        { variant: 'error' }
                    );
                    setRouteLoading(false)
                });
    }
    const saveRoute = () => {
        setSaving(true);
        
        let par = { include: "driver,vehicle.company,vehicle.transport_unit1,vehicle.transport_unit2,vehicle.centre.main_centre_zone,deliveries.receipt,deliveries.survey_answers.survey_question,deliveries.order,deliveries.docs_images_attachments,deliveries.locatable.location,deliveries.delivery_details.images_attachments,deliveries.delivery_details.order_detail,deliveries.delivery_docs.shipping_doc.shipping_doc_kind", custom_order: _.map(newDeliveries, 'id') }
        tripServices.calculateRouteOrder(props.trip?.id, par)
                .then((data) => {
                    setSaving(false)
                    setCanSave(false)
                    enqueueSnackbar('Viaje guardado', { variant: 'success' })
                    // Guardar cierra el instructivo: el orden ya quedo en el viaje y
                    // dejarlo abierto obligaba a apretar Cerrar aparte para ver el
                    // cambio reflejado en la lista. Se cierra pidiendo recarga, porque
                    // el orden nuevo mueve la tarjeta del viaje y los KPI.
                    props.onClose(true)
                })
                .catch((err) => {
                    setSaving(false)
                    // Si falla NO se cierra: lo que quedo en pantalla es el orden que no
                    // se alcanzo a guardar, y cerrando se perderia sin que se note.
                    enqueueSnackbar(
                        err?.response?.data?.error || 'No fue posible guardar el viaje',
                        { variant: 'error' }
                    )
                });
    }

    const onSortEnd = ({oldIndex, newIndex}) => {
        if (oldIndex === newIndex) return;

        setNewDeliveries(arrayMove(newDeliveries, oldIndex, newIndex));
        // El orden nuevo vive solo en memoria hasta que se guarda; `canSave` pinta el boton de
        // verde para que se note que hay algo pendiente.
        setCanSave(true);
    };

    const handleDeliverySelect = (delivery) => {
        setSelectedDelivery(delivery)
        const destination = getDeliveryDestination(delivery);
        if(destination) {
            setMapCenter({lat: destination.lat, lng: destination.lng})
        }
    }

    // Las mismas entregas que dejan sacarse de a una (ver canRemoveDelivery en
    // DeliveryCell): una finalizada o cancelada no se puede destruir.
    const removableDeliveries = newDeliveries.filter((d) => !_.includes(['cancelled', 'finished'], d.state))
    const selectedRemovableIds = selectedForRemoval.filter(
        (id) => removableDeliveries.some((d) => d.id === id)
    )

    const enterSelectMode = () => {
        setSelectMode((active) => {
            const next = !active
            if (next) setSortMode(false)
            if (!next) setSelectedForRemoval([])
            return next
        })
    }

    const toggleDeliveryForRemoval = (deliveryId) => {
        setSelectedForRemoval((previous) => _.xor(previous, [deliveryId]))
    }

    const toggleAllForRemoval = () => {
        setSelectedForRemoval((previous) => (
            previous.length === removableDeliveries.length
                ? []
                : removableDeliveries.map((d) => d.id)
        ))
    }

    // Marcadas TODAS las que se pueden eliminar, la accion deja de ser sacar entregas
    // y pasa a ser eliminar el viaje: eso es lo que dice el boton y lo que hace.
    const todasSeleccionadas = removableDeliveries.length > 0 &&
        selectedRemovableIds.length === removableDeliveries.length
    // Eliminar TODAS las entregas se lleva el viaje: el backend borra un viaje que
    // queda vacio, asi que el aviso tiene que decirlo antes de apretar.
    const quitaTodasLasEntregas = newDeliveries.length > 0 &&
        selectedRemovableIds.length === newDeliveries.length
    const entregasQueQuedanDeHistorial = newDeliveries.length - removableDeliveries.length

    // Con todas marcadas y el viaje todavia en armado se usa el borrado de viaje, que
    // es el unico que sabe soltar las entregas finalizadas como historial. En un viaje
    // en curso no se puede: ahi se eliminan las entregas y el backend se lleva el viaje
    // si queda vacio.
    const confirmarEliminacion = () => {
        if (todasSeleccionadas && canReorderTrip) {
            setConfirmDeleteTrip(true)
            return
        }
        setConfirmBulkRemove(true)
    }

    const removeSelectedDeliveries = () => {
        if (selectedRemovableIds.length === 0) return

        setBulkRemoving(true)
        tripServices.removeDeliveries(props.trip?.id, { delivery_ids: selectedRemovableIds })
            .then((res) => {
                setBulkRemoving(false)
                setConfirmBulkRemove(false)
                setSelectedForRemoval([])
                setSelectMode(false)
                setReloadOnClose(true)

                // El backend se lleva el viaje si le quitamos la ultima entrega, asi
                // que recargar el detalle daria 404: se cierra el instructivo.
                if (res?.trip_deleted) {
                    enqueueSnackbar(
                        `Viaje ${res.trip_code || ''} eliminado: no quedaban entregas.`,
                        { variant: 'success' }
                    )
                    props.onClose(true)
                    return
                }

                enqueueSnackbar(
                    `${selectedRemovableIds.length} entrega(s) eliminada(s) del viaje`,
                    { variant: 'success' }
                )
                loadDetails()
            })
            .catch((err) => {
                setBulkRemoving(false)
                enqueueSnackbar(
                    err?.response?.data?.error || 'No fue posible eliminar las entregas del viaje',
                    { variant: 'error' }
                )
            })
    }

    const deleteWholeTrip = () => {
        setDeletingTrip(true)
        tripServices.deleteTrip(props.trip?.id)
            .then((res) => {
                setDeletingTrip(false)
                setConfirmDeleteTrip(false)
                enqueueSnackbar(
                    `Viaje ${res?.trip_code || props.trip?.code || ''} eliminado`,
                    { variant: 'success' }
                )
                // Quedaron entregas finalizadas o canceladas sueltas: se avisa porque
                // esas no vuelven a estar disponibles para planificar.
                if (res?.detached_deliveries > 0) {
                    enqueueSnackbar(
                        `${res.detached_deliveries} entrega(s) finalizada(s) o cancelada(s) se conservan como historial.`,
                        { variant: 'info' }
                    )
                }
                props.onClose(true)
            })
            .catch((err) => {
                setDeletingTrip(false)
                enqueueSnackbar(
                    err?.response?.data?.error || 'No fue posible eliminar el viaje',
                    { variant: 'error' }
                )
            })
    }

    return (
        <React.Fragment>
            <Dialog
                fullWidth={true}
                // Tope en 1650px, no en el viewport completo: "xl" se cortaba en 1536 y dejaba
                // la lista apretada, pero ocupando todo el ancho de un monitor grande el modal
                // deja de leerse como modal y las filas quedan larguisimas.
                maxWidth={false}
                // `scroll="paper"` y la altura tope dejan el titulo y los botones siempre a la
                // vista: con un viaje de 40 entregas el modal crecia hasta empujar Cerrar y
                // Guardar fuera de la pantalla.
                scroll="paper"
                PaperProps={{sx: {maxHeight: 'calc(100vh - 40px)', maxWidth: 1650}}}
                open={props.isOpen}
                onClose={() => { props.onClose(reloadOnClose) }}>
                <DialogTitle>
                    <Div sx={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 1}}>
                        <Typography variant={"h2"} color="primary">Instructivo Nº{props.trip?.code} ({moment(props.trip?.ship_date).format('DD MMM')})</Typography>
                        <Div sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                            {/* Solo en viajes pendientes: en uno en curso el chofer ya tiene la
                                ruta en su app y quedaria mirando un orden distinto al guardado. */}
                            {canManageTrip && authUser?.current_company?.id !== 80 && canReorderTrip && (
                                <Tooltip
                                    arrow
                                    title="Arrastra las entregas para cambiar el orden. Se aplica al Guardar.">
                                    <ToggleButton
                                        value="sort"
                                        selected={sortMode}
                                        onChange={() => setSortMode((active) => !active)}
                                        size="small"
                                        color="primary"
                                        sx={{textTransform: 'none', px: 1.5, py: 0.5}}>
                                        <SwapVertIcon fontSize="small" sx={{mr: 0.5}} />
                                        Ordenar
                                    </ToggleButton>
                                </Tooltip>
                            )}
                            {/* Un solo boton para eliminar: abre los checkboxes y desde ahi
                                se elige que se va. Marcar todas las entregas es lo que elimina
                                el viaje, asi que no hace falta un boton aparte para eso.
                                Excluyente con Ordenar: la fila se usa tambien para abrir la
                                entrega, y con los tres modos vivos a la vez un click cualquiera
                                hacia otra cosa de la esperada. */}
                            {canManageTrip && authUser?.current_company?.id !== 80 && (
                                <Tooltip
                                    arrow
                                    title={selectMode
                                        ? 'Marca las entregas que quieres eliminar. Si las marcas todas, se elimina el viaje.'
                                        : 'Permite marcar entregas para eliminarlas del viaje.'}>
                                    <ToggleButton
                                        value="select"
                                        selected={selectMode}
                                        onChange={enterSelectMode}
                                        size="small"
                                        color="error"
                                        sx={{textTransform: 'none', px: 1.5, py: 0.5}}>
                                        <DeleteOutlineOutlinedIcon fontSize="small" sx={{mr: 0.5}} />
                                        Eliminar
                                    </ToggleButton>
                                </Tooltip>
                            )}
                            {canManageTrip && authUser?.current_company?.id !== 80 && (
                                /* Optimizar de nuevo sin haber movido nada devuelve exactamente el
                                   mismo orden y cuesta llamadas a HERE. El boton queda inhabilitado
                                   y el tooltip dice por que, en vez de dejar apretar y no pasar nada.
                                   El <span> es necesario: MUI no muestra tooltips sobre un boton
                                   deshabilitado. */
                                <Tooltip
                                    arrow
                                    title={sinCambiosQueOptimizar
                                        ? 'Ya está optimizada. Mueve, agrega o quita una parada para volver a calcular.'
                                        : 'Calcula el mejor orden de las paradas.'}>
                                    <span>
                                        <LoadingButton
                                            loading={routeLoading}
                                            disabled={sinCambiosQueOptimizar}
                                            variant="contained"
                                            color="success"
                                            size="small"
                                            endIcon={<RefreshIcon />}
                                            loadingPosition="end"
                                            onClick={() => calculateRoute()}
                                            /* Sin esto MUI lo escribe en mayusculas y queda
                                               "OPTIMIZAR" al lado de "Ordenar" y "Eliminar". */
                                            sx={{textTransform: 'none'}}>
                                            {routeLoading ? "Calculando" : "Optimizar"}
                                        </LoadingButton>
                                    </span>
                                </Tooltip>
                            )}
                        </Div>
                    </Div>
                    {stopAddressChanged && canManageTrip &&
                        <Alert severity="warning" onClose={() => setStopAddressChanged(false)} sx={{ mb: 1 }}>
                            Cambiaste la dirección de una parada. Haz click en <strong>Optimizar</strong> para volver a asignar la ruta.
                        </Alert>
                    }
                    {/* Como se va a rutear este viaje. Sale del vehiculo (`avoid_tolls`, el check
                        "Evitar peajes y tag" de su ficha) y hasta ahora solo se veia entrando a
                        editarlo, asi que quien planificaba no sabia con que criterio se calculaba
                        la ruta que estaba mirando. */}
                    <Tooltip
                        arrow
                        title={props.trip?.vehicle_avoid_tolls
                            ? 'Del check "Evitar peajes y tag" del vehículo. Al ordenar las paradas el peaje solo se penaliza: puede pasar igual.'
                            : 'El vehículo no tiene marcado "Evitar peajes y tag".'}>
                        <Div sx={{display: 'inline-flex', alignItems: 'center', gap: 0.5, cursor: 'help'}}>
                            <TollOutlinedIcon fontSize="small" color="action" />
                            <Typography variant={"caption"} color={"text.secondary"}>
                                {props.trip?.vehicle_avoid_tolls
                                    ? 'La optimización de esta ruta no incluye tag y peajes'
                                    : 'La optimización de esta ruta incluye tag y peajes'}
                                {/* La patente identifica al vehiculo para quien planifica; el
                                    `vehicle_code` queda de respaldo para los que no la tienen
                                    cargada, que si no dejaria la linea sin decir de cual habla. */}
                                {props.trip?.ppu1 || props.trip?.vehicle_code
                                    ? ` (Vehículo ${props.trip.ppu1 || props.trip.vehicle_code})`
                                    : ' (sin vehículo asignado)'}
                            </Typography>
                        </Div>
                    </Tooltip>
                </DialogTitle>
                <DialogContent>
                    {deliveriesLoading ?
                        <Div sx={{textAlign: 'center', my: 5}}>
                            <CircularProgress color="warning"/>
                        </Div>
                    :
                        <React.Fragment>
                            <Grid container spacing={2}>
                                <Grid item xs={12} md={5}>
                                    {renderMap()}
                                </Grid>
                                <Grid item xs={12} md={7}>
                                    {canManageTrip && authUser?.current_company?.id !== 80 && (
                                        <>
                                            <Typography variant={"h4"} sx={{ mb: 0 }}>
                                                Planificación de entregas
                                            </Typography>
                                            <Typography variant={"caption"} color={"text.secondary"}>
                                                {selectMode
                                                    ? 'Marca las entregas que quieres eliminar del viaje'
                                                    : !canReorderTrip
                                                        ? 'El orden de las entregas solo se puede cambiar mientras el viaje esta planificado o pendiente'
                                                        : sortMode
                                                            ? 'Arrastra y suelta las entregas para reordenarlas'
                                                            : 'Activa Ordenar para arrastrar y reordenar las entregas'}
                                            </Typography>
                                        </>
                                    )}
                                    {/* Barra del modo seleccion. Va arriba de la lista y no
                                        abajo: la lista scrollea sola y al final de 40 entregas
                                        el boton quedaba fuera de la vista. */}
                                    {selectMode && canManageTrip && (
                                        <Stack
                                            direction="row"
                                            alignItems="center"
                                            justifyContent="space-between"
                                            spacing={1}
                                            sx={{
                                                mt: 1,
                                                px: 1,
                                                py: 0.5,
                                                borderRadius: 1,
                                                bgcolor: 'action.hover',
                                            }}>
                                            <Stack direction="row" alignItems="center" spacing={0.5}>
                                                <Checkbox
                                                    size="small"
                                                    disableRipple
                                                    checked={removableDeliveries.length > 0 &&
                                                        selectedRemovableIds.length === removableDeliveries.length}
                                                    indeterminate={selectedRemovableIds.length > 0 &&
                                                        selectedRemovableIds.length !== removableDeliveries.length}
                                                    disabled={removableDeliveries.length === 0}
                                                    onChange={toggleAllForRemoval}
                                                />
                                                <Typography variant={"body2"}>
                                                    {selectedRemovableIds.length} de {removableDeliveries.length} seleccionada(s)
                                                </Typography>
                                            </Stack>
                                            <LoadingButton
                                                loading={bulkRemoving}
                                                disabled={selectedRemovableIds.length === 0}
                                                variant="contained"
                                                color="error"
                                                size="small"
                                                startIcon={<DeleteOutlineOutlinedIcon fontSize="small" />}
                                                onClick={confirmarEliminacion}
                                                sx={{textTransform: 'none'}}>
                                                {bulkRemoving
                                                    ? 'Eliminando'
                                                    : todasSeleccionadas ? 'Eliminar viaje' : 'Eliminar del viaje'}
                                            </LoadingButton>
                                        </Stack>
                                    )}
                                    {/* La lista se acota y scrollea sola: sin esto un viaje
                                        de 40 entregas estiraba el modal hasta dejar Cerrar y
                                        Guardar fuera de la pantalla. El mapa queda fijo al
                                        lado en vez de irse con el scroll. */}
                                    <Div sx={{maxHeight: 'calc(100vh - 306px)', minHeight: 200, overflowY: 'auto', pr: 0.5}}>
                                        <Deliveries
                                            tripId={props.trip?.id}
                                            getStopKey={(d) => getDeliveryDestination(d)?.key}
                                            tripState={props.trip?.state}
                                            deliveries={newDeliveries}
                                            onSortEnd={onSortEnd}
                                            distance={1}
                                            // useDragHandle={true}
                                            _selectedDelivery={selectedDelivery}
                                            canSort={canManageTrip && canReorderTrip && sortMode}
                                            canManageTrip={canManageTrip}
                                            selectMode={selectMode}
                                            selectedForRemoval={selectedForRemoval}
                                            onToggleSelectForRemoval={toggleDeliveryForRemoval}
                                            onSelect={handleDeliverySelect}
                                            lockAxis={'y'}
                                            dropoffMapPoint={selectedPickupPoint}
                                            onDropoffMapContextChange={handleDropoffMapContextChange}
                                            onDropoffSearch={handlePickupSearch}
                                            onDropoffSearchClear={() => {
                                                pickupSearchRequestRef.current += 1;
                                                setPickupPoints(selectedPickupPoint ? [selectedPickupPoint] : []);
                                                setLoadingPickupPoints(false);
                                            }}
                                            dropoffSearchLoading={loadingPickupPoints}
                                            onAdd={(d) => { setReloadOnClose(true); clearPickupMode(); loadDetails() }}
                                            // Cambio de direccion de una parada, o una direccion nueva del
                                            // cliente: se recarga para mover el pin y rearmar la ruta.
                                            onAddressChanged={(d, opts) => {
                                                setReloadOnClose(true);
                                                loadDetails();
                                                // La firma de Optimizar son solo los ids: con las mismas
                                                // paradas en otro lugar dejaba el boton bloqueado.
                                                if (opts?.stopMoved) {
                                                    setStopAddressChanged(true);
                                                    setOptimizedSignature(null);
                                                }
                                            }}
                                            mapsLoaded={isLoaded}
                                            onRemove={(d, res) => {
                                                setReloadOnClose(true);
                                                // El viaje se va con su ultima entrega, asi que
                                                // recargar el detalle daria 404: se cierra.
                                                if (res?.trip_deleted) {
                                                    enqueueSnackbar(`Viaje ${res.trip_code || ''} eliminado: no quedaban entregas.`, { variant: 'success' });
                                                    props.onClose(true);
                                                    return;
                                                }
                                                loadDetails();
                                            }} />

                                        {/* Fila de cierre del viaje.
                                            Va FUERA de <Deliveries>, que es el SortableContainer:
                                            no es una entrega, no se arrastra y no entra en el
                                            reordenamiento. Y va aca dentro del Div que scrollea
                                            para que quede pegada a la ultima parada y no flotando
                                            debajo de la lista.

                                            El instructivo se lee e imprime como lista, asi que el
                                            cierre tiene que poder leerse sin mirar el mapa. */}
                                        {destinationLoc && (
                                            <Stack
                                                direction="row"
                                                alignItems="center"
                                                spacing={1.5}
                                                sx={{
                                                    mt: 1,
                                                    px: 1.5,
                                                    py: 1,
                                                    borderRadius: 1,
                                                    border: '1px solid',
                                                    borderColor: 'divider',
                                                    bgcolor: 'action.hover',
                                                }}>
                                                <Avatar sx={{ width: 28, height: 28, bgcolor: FINISH_MARKER_COLOR }}>
                                                    <FlagRoundedIcon sx={{ fontSize: 16 }} />
                                                </Avatar>
                                                <Div sx={{ minWidth: 0 }}>
                                                    <Typography variant="body2" fontWeight={600} noWrap>
                                                        Llegada{destinationName ? ` · ${destinationName}` : ''}
                                                    </Typography>
                                                    <Typography variant="caption" color="text.secondary" noWrap component="div">
                                                        {[destinationLoc.short_address, destinationLoc.short_zone]
                                                            .filter(Boolean).join(' | ')}
                                                    </Typography>
                                                </Div>
                                            </Stack>
                                        )}
                                    </Div>
                                </Grid>
                            </Grid>
                        </React.Fragment>
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => { setCanSave(false); props.onClose(reloadOnClose) } }>Cerrar</Button>
                    {canManageTrip && (
                        <LoadingButton
                            loading={saving}
                            variant="contained"
                            color={ canSave ? 'success' : 'primary' }
                            size='small'
                            endIcon={<SaveOutlinedIcon/>}
                            loadingPosition="end"
                            onClick={() => saveRoute()}>
                                { saving ? 'Guardando' : 'Guardar' }
                        </LoadingButton>
                    )}
                </DialogActions>
            </Dialog>
            <ConfirmDialog
                open={confirmBulkRemove}
                title={quitaTodasLasEntregas ? "Eliminar las entregas y el viaje" : "Eliminar entregas del viaje"}
                message={
                    <>
                        ¿Estás seguro que deseas eliminar <strong>{selectedRemovableIds.length} entrega(s)</strong> del viaje <strong>Nº{props.trip?.code}</strong>?
                        <br />
                        {/* Mismo aviso que el borrado de a una: un viaje sin entregas no se
                            puede cerrar ni completar, asi que el backend se lo lleva. */}
                        { quitaTodasLasEntregas
                            ? <>Son <strong>todas</strong> sus entregas, así que también se elimina el viaje <strong>Nº{props.trip?.code}</strong> completo. Esto no se puede deshacer. Los pedidos vuelven a quedar disponibles para planificar.</>
                            : 'Los pedidos vuelven a quedar disponibles para planificar.' }
                    </>
                }
                loading={bulkRemoving}
                onClose={() => setConfirmBulkRemove(false)}
                onConfirm={removeSelectedDeliveries}
            />
            <ConfirmDialog
                open={confirmDeleteTrip}
                title="Eliminar el viaje completo"
                message={
                    <>
                        ¿Estás seguro que deseas eliminar el viaje <strong>Nº{props.trip?.code}</strong> con sus <strong>{newDeliveries.length} entrega(s)</strong>?
                        <br />
                        Esto no se puede deshacer. Los pedidos vuelven a quedar disponibles para planificar.
                        {/* Las finalizadas y canceladas no se pueden destruir y quedan como
                            historial sin viaje: se avisa antes, no despues. */}
                        { entregasQueQuedanDeHistorial > 0 && (
                            <>
                                <br />
                                <strong>{entregasQueQuedanDeHistorial} entrega(s)</strong> finalizada(s) o cancelada(s) se conservan como historial y sus pedidos no vuelven a estar disponibles.
                            </>
                        )}
                    </>
                }
                loading={deletingTrip}
                onClose={() => setConfirmDeleteTrip(false)}
                onConfirm={deleteWholeTrip}
            />
        </React.Fragment>
    )
}

const Deliveries = SortableContainer(({ tripId, tripState, deliveries, getStopKey, _selectedDelivery, canSort = false, canManageTrip = false, onSelect, onAdd, onRemove, onAddressChanged, mapsLoaded = false, dropoffMapPoint, onDropoffMapContextChange, onDropoffSearch, onDropoffSearchClear, dropoffSearchLoading, selectMode = false, selectedForRemoval = [], onToggleSelectForRemoval }) => {
    // Misma numeracion que los pines del mapa (utils/tripStops).
    const stopNumbers = stopNumbersByDeliveryId(deliveries);
    return (
        <List
            dense={true}
            sx={{ padding: 0 }}>
                {/* El formulario de agregar parada se esconde mientras se marcan entregas
                    para quitar: son acciones opuestas y ocupa la primera fila de la lista. */}
                {canManageTrip && !selectMode && (
                    <DeliveryCell
                        formNew={true}
                        disabled={!canSort}
                        canManageTrip={canManageTrip}
                        // El formulario nuevo necesita las entregas del viaje para el
                        // paso a paso de dropoff masivo, que trabaja sobre lo ya agregado.
                        deliveries={deliveries}
                        onAdd={onAdd}
                        dropoffMapPoint={dropoffMapPoint}
                        onDropoffMapContextChange={onDropoffMapContextChange}
                        onDropoffSearch={onDropoffSearch}
                        onDropoffSearchClear={onDropoffSearchClear}
                        dropoffSearchLoading={dropoffSearchLoading}
                        tripState={tripState}
                        tripId={tripId} />
                )}
                    
                {deliveries?.map((delivery, index) => {
                    return (
                        <DeliveryCell
                            key={delivery.code}
                            index={index}
                            delivery={delivery}
                            selected={_selectedDelivery?.id === delivery.id}
                            canSort={canSort}
                            canManageTrip={canManageTrip}
                            disabled={!canSort}
                            onSelect={onSelect}
                            stop={stopNumbers[delivery.id]}
                            onRemove={onRemove}
                            onAddressChanged={onAddressChanged}
                            mapsLoaded={mapsLoaded}
                            selectMode={selectMode}
                            selectedForRemoval={_.includes(selectedForRemoval, delivery.id)}
                            onToggleSelectForRemoval={onToggleSelectForRemoval}
                            isLastDelivery={deliveries?.length === 1}
                            tripState={tripState}
                            tripId={tripId}
                            itemStyle={{
                                borderTop: '1px solid #EEE',
                            }} />
                    )
                })}
        </List>
    )
})

export default RouteBuilder;
